import { z } from 'zod';

import { medicationDeliveryConstants } from '@ui/routes/shared/MedicationDeliveryStep';

import { commonErrors } from '@utils/error';
import { requiredString } from '@utils/validation';

export const testContent = {
	heading: 'How would you like to get your medications?',
	sub_heading: 'Choose which method you would like to use.',
	capsule_disclaimer:
		'*FOLX cannot guarantee Capsule inventory or time to stock, or medication cost (with or without insurance).',
	capsule_info_link_text: 'Learn more about Capsule',
	capsule_info_link_url: '/',
	folx_shipping: {
		shipping_header: 'Shipped by FOLX ',
		shipping_description:
			'<p>Discreet shipping to your door, included in your membership. Your medication arrives within 5-7 days once your clinician orders your meds.</p>',
		shipping_price: 'Starting at $59',
		shipping_price_interval: 'mo',
		enabled: true,
	},
	capsule_delivery: {
		capsule_header: 'Same-day delivery (Rx Only)*',
		capsule_description:
			'<p>RX ordered by FOLX and sent to Capsule. Same-day delivery at no extra cost, once your clinician orders your meds.</p>',
		membership_price: '$59',
		membership_price_interval: 'for FOLX membership',
		copay_price: '+copay',
		copay_price_description: 'paid to Capsule',
		enabled: true,
	},
};

export const schema = z.object({
	[medicationDeliveryConstants.MEDICATION_DELIVERY_METHOD]: requiredString(
		commonErrors.selectionRequired
	),
});
